import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Grid, IconButton, List, ListItem, Paper, TextField, ThemeProvider, Tooltip, Typography, useTheme } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import '../../../Styles/react-tagsinput.css'
import { ContextNotification, severitys } from "../../../App";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import FlightCompensationApi from "../../../api/FlightCompensationApi";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import staticData from "../../../data/StaticData";
import { DataGrid } from "@mui/x-data-grid";
import ConfirmationDialog from "../../../Components/ConfirmationDialog";
import { MdAdd, MdDelete, MdEditSquare, MdExpandLess, MdExpandMore } from "react-icons/md";
import staticVariablesApi from "../../../api/staticVariablesApi";

const EditFlightComTransport = ({ flightData }) => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const { setOpen } = useContext(ContextNotification);
    const customization = useSelector((state) => state.customization);
    const [isloading, setIsLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [brokers, setBrokers] = useState([]);
    const [freePassengers, setFreePassengers] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [costItems, setCostItems] = useState([]);
    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
         defaultValues: {
            brokerID:null,
            passengerID:null
         },
        resolver: yupResolver(schema),
    });
    const Columns = [
    {  headerName: "نام کارگزاری", width: '200',renderCell: (cellValues) =>{return cellValues.row.kargozarCode!=null?cellValues.row.kargozarCode+' - '+cellValues.row.brokerGroupCode+' - '+cellValues.row.kargozarName:''} },
            { field: "fullName", headerName: " نام مسافر آزاد", width: '150' },

    ];
    Columns.push({
        field: "ویرایش", renderCell: (cellValues) => {
            return (
                <IconButton
                    disabled={isloading}
                    sx={{ color: '#4a148c' }}
                    onClick={() => {
                        handleOpenEdit(cellValues.row)
                    }}><MdEditSquare />
                </IconButton>
            )
        }
    });
    Columns.push({
        field: "حذف", renderCell: (cellValues) => {
            return (
                <IconButton
                    disabled={isloading}
                    sx={{ color: '#c70c05c2' }}
                    onClick={() => {
                        handleOpenDelete(cellValues.row)
                    }}><MdDelete />
                </IconButton>
            )
        }
    });
    useEffect(() => {
        resetForm();
        setBrokers(flightData?.tripGroupMembersResponses?.filter((itm) => itm.brokerCode !== null).map((o) => {
            return {
                id: o.brokerId,
                label: o.brokerCode + '-' + o.brokerName
            };
        }));
        setFreePassengers(flightData?.tripPassengerMembersResponses?.filter(itm => (itm.flightAttendanceStatus === false)).map((o) => {
            return {
                id: o.passengerId,
                label: o.sSn + '-' + o.fullName
            };
        }));
    }
        , [flightData])

    useEffect(() => {
        GetVehicleTypeDropDown();
    }, []);

    const GetVehicleTypeDropDown = () => {
        staticVariablesApi.GetVehicleTypeDropDown().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setVehicleTypes(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        })
            .catch((error1) => {
                console.log(error1);
            })

    }


    const resetForm = () => {
        clearCostData();
        setSelectedCompensation(null);
        setOpenDelete(false);
        setOpenDeletecost(false);
        setDeleteData(null);
        setDeletedCost(null);
        GetData();
    }

    const GetData = (selectedcostid) => {
        setRows([]);
        if (flightData?.flightId) {
            setIsLoading(true);
            FlightCompensationApi.GetFlightCompTransportByFlightId(flightData?.flightId).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setRows(res.data.data);
                        const scompensation = (selectedcostid ? res.data.data.find(itm => itm.id === selectedcostid) : null);
                        setSelectedCompensation(scompensation);
                        if (scompensation?.flightCompensationForGroupTransfer) {
                            fillNewCostItems(scompensation.flightCompensationForGroupTransfer.map((itm, index) => {

                                return {
                                    'id': itm.fcTransferId ? itm.fcTransferId : null,
                                    'index': index,
                                    'vehicleType':itm.vehicleType!==null?String(itm.vehicleType):null,
                                    'passengerCount': itm.passengerCount!==null?String(itm.passengerCount):null,
                                    'transferRate':itm.transferRate!==null? String(itm.transferRate):null,
                                    'description':itm.description!==null? String(itm.description):null
                                }
                            }));
                        }
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در دریافت اطلاعات', severity: severitys.error });
                    }
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => { setIsLoading(false) });
        }
    }
    ////costs/////////////////////////////////////

    const [errorRequiredIndex, setErrorRequiredIndex] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(false);

    const clearCostData = () => {

        setOpenDropdown(true);
        setErrorRequiredIndex([]);
        setOpenDelete(false);
        setDeleteData(null);
             var costdata = {
                'id': null,
                'index':  0,
                'vehicleType':null,
                'passengerCount': null,
                'transferRate': null,
                'description': "",
            }

            fillNewCostItems([costdata]);
            setOpenDropdown(true);
    }
    const resetCostData = (selectedcost) => {
        GetData(selectedcost?.id);
        setOpenDropdown(true);

    }
    const AddNewRow = () => {

        if ((selectedCompensation === null) || (selectedCompensation.flightCompensationForGroupTransfer?.length === costItems.length)) {
            var maxindex = costItems.length > 0 ? Math.max(...costItems.map(a => { return a.index })) : 0;
            var costdata = {
                'id': null,
                'index': maxindex + 1,
                'vehicleType':null,
                'passengerCount': null,
                'transferRate': null,
                'description': "",
            }

            fillNewCostItems([...costItems, costdata]);
            setOpenDropdown(true);
        }

    }
    const fillNewCostItems = (costdata) => {
        setCostItems(costdata);
                    var errors=[];
        costdata.map((itm, index) => {
            setValue('vehicleType' + String(itm.index), itm.vehicleType);
             setValue('passengerCount' + String(itm.index), itm.passengerCount);
            setValue('transferRate' + String(itm.index), itm.transferRate);
            setValue('description' + String(itm.index), itm.description);

            if(itm.vehicleType===null) errors=[...errors,{ "index": itm.index, "value": "vehicleType" }]
            if(itm.passengerCount===null) errors=[...errors,{ "index": itm.index, "value": "passengerCount" }]
            if(itm.transferRate===null) errors=[...errors,{ "index": itm.index, "value": "transferRate" }]
          
        });
        setErrorRequiredIndex(errors);
    }

    const EditCost = (costdata) => {
        var pvehicleType = costdata.vehicleType;
        var ppassengerCount = costdata.passengerCount;
        var ptransferRate = costdata.transferRate;
        var pdescription = costdata.description ?? null;

        const editcostdata = {
            'vehicleType':parseInt(pvehicleType),
            'passengerCount': parseInt(ppassengerCount),
            'transferRate': parseInt(ptransferRate),
            'description': pdescription?String(pdescription):null,

        }

        if ((!errorRequiredIndex.some(itm => itm.index === costdata.index)) && (costdata.id !== null))//edit cost
        {

            setIsLoading(true);
            FlightCompensationApi.UpdateTransport(costdata.id, editcostdata).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت ویرایش شد', severity: severitys.success });
                        resetCostData(selectedCompensation);
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => {
                setIsLoading(false);
            });

        }
        else//add cost
        {
            if ((!errorRequiredIndex.some(itm => itm.index === costdata.index)) && (selectedCompensation?.id)) {

                setIsLoading(true);
                FlightCompensationApi.AddTransport(selectedCompensation?.id, editcostdata).then(res => {
                    if (res.status === 200) {
                        if (res.data.success) {
                            setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت افزوده شد', severity: severitys.success });
                            resetCostData(selectedCompensation);
                        }
                        else {
                            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                        }
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }

                }).catch(err => {

                    if (err.response && err.response.data) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.response && err.response.data && err.response.data.errors) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                    }

                }).finally(() => {
                    setIsLoading(false);
                });

            }
        }

    }

    ///delete/////////////////////////////////////
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteData, setDeleteData] = useState(null);
    const handleOpenDelete = (data) => {
        setOpenDelete(true);
        setDeleteData(data);
    };
    const handleDeleteRow = () => {
        setIsLoading(true);
        FlightCompensationApi.deleteFlightCompTransport(deleteData.id).then(res => {
            if (res.status === 200) {
                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت حذف شد', severity: severitys.success });
                    resetForm();
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

                }

            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {

            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => {
            setIsLoading(false);
            setOpenDelete(false);
        });
    }
    //////deleteCost
    const [openDeletecost, setOpenDeletecost] = useState(false);
    const [deletedCost, setDeletedCost] = useState(null);
    const handlecloseDeleteCost = () => {
        setOpenDeletecost(false);
        setDeletedCost(null);
    }
    const DeleteCost = (costitem) => {
        if (costitem.id !== null) {
            setDeletedCost(costitem);
            setOpenDeletecost(true);
        }
        else {
            fillNewCostItems(costItems?.filter((itm) => itm.index !== costitem.index));
        }
    }
    const handleDeleteCost = () => {

        setIsLoading(true);
        FlightCompensationApi.deleteTransport(deletedCost.id).then(res => {
            if (res.status === 200) {
                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت حذف شد', severity: severitys.success });
                    resetCostData(selectedCompensation);
                    handlecloseDeleteCost();

                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {

            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => {
            setIsLoading(false);
            setOpenDeletecost(false);
        });

    }


    ////////Edit/////////////////////////
    const [selectedCompensation, setSelectedCompensation] = useState(null);
    const handleOpenEdit = (data) => {
        if (selectedCompensation?.id === data.id) {
            setSelectedCompensation(null);
            clearCostData();

        }
        else {
            resetCostData(data);
        }
    }
    ////////////////////////

    const DoSave = (data) => {
        var pbrokerGroupNo = null;
        var pbrokerID = null;
        if (data.brokerID) {
            var broker = flightData?.tripGroupMembersResponses?.find((itm) => itm.brokerId === data.brokerID);
            pbrokerGroupNo = String(broker.groupNo);
            pbrokerID = String(data.brokerID);
        }
        var ppassengerId = null;
        if (data.passengerID)
            ppassengerId = String(data.passengerID);


        if ((costItems?.length > 0) && ((pbrokerID !== null) || (ppassengerId !== null)) && (errorRequiredIndex.length === 0)) {
            const compdata = {
                "brokerId": pbrokerID,
                "passengerId": ppassengerId,
                "brokerGroupNo": pbrokerGroupNo,
                "fcTransferList": costItems.map((itm) => {
                    return {
                        'vehicleType':parseInt(itm.vehicleType),
                        'passengerCount': parseInt(itm.passengerCount),
                        'transferRate': parseInt(itm.transferRate),
                        'description': itm.description?String(itm.description):null
                    }
                })
            }
            setSubmitLoading(true);

            if (selectedCompensation === null)//add mode
            {
                FlightCompensationApi.AddFlightCompTransport(flightData?.flightId, compdata).then(res => {
                    if (res.status === 200) {
                        if (res.data.success) {
                            setOpen({ IsEnable: true, Message: 'هزینه با موفقیت افزوده شد', severity: severitys.success });
                            resetForm();

                        }
                        else {
                            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                        }
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }

                }).catch(err => {

                    if (err.response && err.response.data) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.response && err.response.data && err.response.data.errors) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                    }

                }).finally(() => { setSubmitLoading(false) });
            }

        }
    }

    const handleChangeVehicleType = (value, costItem) => {
            costItem.vehicleType = value;
            if (value!==null) {
                setErrorRequiredIndex(errorRequiredIndex.filter(item => ((item.index !== costItem.index) || (item.value !== "vehicleType"))));
            }

            else {
                setErrorRequiredIndex([...errorRequiredIndex.filter(item => ((item.index !== costItem.index) || (item.value !== "vehiceType"))), { "index": costItem.index, "value": "vehicleType" }]);
            }

    }
    const handleChangePassengerCount = (value, costItem) => {

        costItem.passengerCount = null;
            if ((value!==null) && (parseInt(value) > 0)) {
                costItem.passengerCount = value;
                setErrorRequiredIndex(errorRequiredIndex?.filter(item => ((item.index !== costItem.index) || (item.value !== "passengerCount"))));
            }

            else {

                setValue("passengerCount" + String(costItem.index), null);
                setErrorRequiredIndex([...errorRequiredIndex?.filter(item => ((item.index !== costItem.index) || (item.value !== "passengerCount"))), { "index": costItem.index, "value": "passengerCount" }]);
            }

    }
    useEffect(()=>{
    },[errorRequiredIndex])
    const handleChangeTransferRate = (value, costItem) => {

        costItem.transferRate = null;
            if ((value!==null) && (parseInt(value) > 0)) {
                costItem.transferRate = value;
                setErrorRequiredIndex(errorRequiredIndex?.filter(item => ((item.index !== costItem.index) || (item.value !== "transferRate"))));
            }

            else {
                setValue("transferRate" + String(costItem.index), null);
                setErrorRequiredIndex([...errorRequiredIndex?.filter(item => ((item.index !== costItem.index) || (item.value !== "transferRate"))), { "index": costItem.index, "value": "transferRate" }]);
            }

    }
    const handlechangeDescription = (value, costItem) => {
        costItem.description = value;
    }
    const handlebrokerIDChanged = () => {


        if ((watch("brokerID")) && (watch("brokerID") !== null)) {
            setValue("passengerID", null);
        }

    }
    const handlepassengerIDChanged = () => {
        if ((watch("passengerID")) && (watch("passengerID") !== null)) {
            setValue("brokerID", null);
        }

    }
    return (
        <Box sx={{ m: 2 }}>
            <ThemeProvider theme={customtheme(customization)}>
                <RtlProvider>
                    <form onSubmit={handleSubmit(DoSave)}>
                        <Grid container spacing={1} m={1}>
                            <Grid container spacing={1} m={1}>
                                {(selectedCompensation === null) && <>
                                  <Grid item md={2.5} xs={7}>
                                    <RHFAutocomplete
                                        control={control}
                                        options={brokers ?? []}
                                        name="brokerID"
                                        onChange={handlebrokerIDChanged}
                                        placeholder="گروه"
                                        style={{
                                            border: "none",
                                            padding: 0
                                        }}
                                    />
                                     
                                      
                                </Grid>
                                    <Grid item md={2.5} xs={7}>
                                        <RHFAutocomplete
                                            control={control}
                                            options={freePassengers ?? []}
                                            name="passengerID"
                                            onChange={handlepassengerIDChanged}
                                            placeholder="مسافر آزاد"
                                            style={{
                                                border: "none",
                                                padding: 0
                                            }}
                                        />
                                    </Grid>
                                    </>}
                                {
                                    (selectedCompensation?.kargozarCode) && <Typography sx={{ m: 1 }}>{selectedCompensation?.kargozarCode + '-' + selectedCompensation?.kargozarName}</Typography>
                                }
                                {
                                    (selectedCompensation?.fullName) && <Typography sx={{ m: 1 }}>{selectedCompensation?.fullName}</Typography>
                                }
                                <Tooltip title="افزودن هزینه">
                                    <IconButton edge="end" aria-label={'افزودن'} onClick={() => AddNewRow()}>
                                        <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                                        <MdAdd size={24} />
                                    </IconButton>
                                </Tooltip>

                                {costItems?.length > 0 && <IconButton edge="end" aria-label="مشاهده  خدمات حمل و نقل " onClick={() => { setOpenDropdown((old) => !old) }}>
                                    {openDropdown ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}
                                </IconButton>}
                               
                            </Grid>
                   {(selectedCompensation===null)&&((!watch("brokerID"))||(watch("brokerID")===null))&&((!watch("passengerID"))||(watch("passengerID")===null)) &&
                                                            <p className="error">{' شماره گروه یا  مسافر آزاد را مشخص کنید'}</p>
                                                        }

                            {(openDropdown) && <List sx={{ width: '100%' }}>
                                {costItems?.sort((a, b) => a.index >= b.index ? 1 : -1).map((item) => {
                                    return (
                                        <Box sx={{ bgcolor: '#F1F1E8', borderRadius: 4, width: '100%' }}>
                                            <ListItem>
                                                <Grid container spacing={1}>

                                                    <Grid item md={1.5} xs={7}>
                                                        <TextField
                                                            type="number"
                                                            label="تعداد مسافر"
                                                            focused={(item.id!==null)}
                                                              {...register("passengerCount" + String(item.index))}
                                                            onChange={(event) => { handleChangePassengerCount(event.target.value, item); }}
                                                            fullWidth></TextField>
                                                        {errorRequiredIndex?.some((itm) => ((itm.index === item.index) && (itm.value === "passengerCount"))) &&
                                                            <p className="error">{' تعداد مسافر را مشخص کنید'}</p>
                                                        }
                                                    </Grid>
                                                    <Grid item md={1.5} xs={7}>
                                                        <RHFAutocomplete
                                                            control={control}
                                                            disabled={(item.id!==null)}
                                                            options={vehicleTypes??[]}
                                                            name={'vehicleType' + String(item.index)}
                                                            defaultValue={String(item.vehicleType)}
                                                            onChange={(event) => { handleChangeVehicleType(event, item); }}
                                                            placeholder="نوع وسیله نقلیه "
                                                            style={{
                                                                border: "none",
                                                                padding: 0
                                                            }}
                                                        />
                                                        {errorRequiredIndex?.some((itm) => ((itm.index === item.index) && (itm.value === "vehicleType"))) &&
                                                            <p className="error">{' نوع وسیله نقلیه را مشخص کنید'}</p>
                                                        }
                                                    </Grid>
                                                    <Grid item md={2} xs={7}>
                                                        <TextField
                                                            type="number"
                                                            label="نرخ وسیله نقلیه"
                                                            focused={(item.id!==null)}
                                                            {...register("transferRate" + String(item.index))}
                                                            onChange={(event) => { handleChangeTransferRate(event.target.value, item); }}
                                                            fullWidth></TextField>
                                                        {errorRequiredIndex?.some((itm) => ((itm.index === item.index) && (itm.value === "transferRate"))) &&
                                                            <p className="error">{' نرخ وسیله نقلیه را وارد کنید'}</p>
                                                        }
                                                    </Grid>
                                                    <Grid item md={5} xs={12}>
                                                        <TextField
                                                            label=" توضیحات "
                                                            focused={(item.id!==null)}
                                                            {...register("description" + String(item.index))}
                                                            onChange={(event) => { handlechangeDescription(event.target.value, item); }}
                                                            ></TextField>
                                                        {(selectedCompensation !== null) && <Tooltip sx={{ mt: 2 }} title="ویرایش">
                                                            <IconButton edge="end" aria-label={'ویرایش'} onClick={() => EditCost(item)}>
                                                                <BeatLoading loading={isloading} color={"#e65100"}  />
                                                                <MdEditSquare color='#4a148c' />
                                                            </IconButton>
                                                        </Tooltip>}
                                                        <Tooltip sx={{ mt: 2 }} title="حذف">
                                                            <IconButton edge="end" aria-label={'حذف'} onClick={() => DeleteCost(item)}>
                                                                <BeatLoading loading={isloading} color={"#e65100"}  />
                                                                <MdDelete color='#C7253E' />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </ListItem>
                                        </Box>
                                    )
                                })}
                            </List>
                            }
                            {(selectedCompensation === null)&&(costItems?.length>0) && <Grid item md={7} xs={7.5}>
                                <Button type="submit" disabled={submitLoading} sx={{ mt: 1 }} variant="contained" color="primary" fullwidth >
                                    <BeatLoading loading={submitLoading} color={"#e65100"} /> {'ثبت هزینه'}</Button>
                            </Grid>
                            }

                        </Grid>


                        <Paper sx={{ mt: 2, width: "100%", height: "500px" }}>
                            <DataGrid
                                rows={rows}
                                columns={Columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 50,
                                        },
                                    },
                                }}
                                pageSizeOptions={[25, 50, 100]}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                                disableColumnMenu
                                disableColumnSelector
                                loading={isloading}
                                sx={{
                                    backgroundColor: '#F1F1E8', // Set your desired background color    
                                    '& .MuiDataGrid-columnHeaders > div[role="row"]': {
                                        color: '#F1F1E8!important',
                                        backgroundColor: '#50a193ff!important',
                                    },
                                }}
                            />
                        </Paper >
                        <ConfirmationDialog
                            open={openDelete}
                            handleClose={() => setOpenDelete(false)}
                            deleteFunction={handleDeleteRow}
                        />
                        <ConfirmationDialog
                            open={openDeletecost}
                            handleClose={handlecloseDeleteCost}
                            deleteFunction={handleDeleteCost}
                        />
                    </form>
                </RtlProvider>
            </ThemeProvider>
        </Box >
    )
}
export default EditFlightComTransport;